<template>
  <common-page-table
    :classHelp="'userPage'"
    custom-expand
    :onExpand="onExpand"
    :dataExpand="dataExpand"
    rowKey="userId"
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('Пользователи')"
    :paramsGetData="paramsGetData"
    :hasLang="false"
    :prefixEdit="`/user`"
    :prefixShow="`/user`"
    :linkCreate="`/user/create`"
    :keyTable="'userId'"
    :alternativeConverter="alternativeConverter"
    :isDefaultConverter="false"
    :deleteParams="deleteParams"
    :apiDeleteName="apiDeleteName"
    :wAction="250"
    :expandParamsPaginator="paramsPaginator"
    @loadCompany="loadCompany"
  />
</template>
<script>
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import {API_METHODS, DEFAULT_PER_PAGE, FIELD_LANG_CODE} from "../../../../constant";
import formatData from "../../../../helpers/converters/formatData";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
import {ApiService} from "@/util/ApiService";
import userPage from "@/components/modules/user/UserPage.vue";
import TheTable from "../../commonElement/TheTable.vue";
import {getRowPaginator} from "../../../../util/entitiesApi/hrFeedFields";

export default {
  name: "UserPage",
  components: {TheTable, CommonPageTable },
  emit: ['set-expand-perPage', 'set-expand-page'],
  data() {
    return {
      paramsPaginator: {
        page: 1,
        size: DEFAULT_PER_PAGE,
        countPage: 1,
        orderBy: null,
        search: "",
        orderDir: "ascending"
      },
      loadDataCompany: {},
      fieldLang: "",
      apiName: API_METHODS.GET_ALL_USER,
      apiDeleteName: API_METHODS.DELETE_USER
    };
  },
  computed: {
    userPage() {
      return userPage
    },
    paramsGetData() {
      return { UserId: this.$route.params.UserIdId };
    },
    nameRoleEntity() {
      return NAME_OBJECT.Admin
    }
  },
  methods: {
    async loadCompany(params) {
      const savedPerPage = this.getPerPageFromSessionStorage(params.row);
      if (savedPerPage) {
        this.paramsPaginator.size = savedPerPage;
      }
      if (params.payload && params.row) {
        await this.fetchCompanyData(params.row, {
          page: params.payload?.page || 1,
          size: params.payload?.size || DEFAULT_PER_PAGE,
          lang: this.$store.state.common.lang,
        })
      }
    },

    getPerPageFromSessionStorage(row) {
      const userId = row && row?.userId ? row.userId : null;
      return getRowPaginator(userId)
    },

    dataExpand(row) {
      if(this.loadDataCompany[row.userId]) {
        return this.loadDataCompany[row.userId];
      }
      return {object: []}
    },

    async onExpand(row) {
      const savedPerPage = this.getPerPageFromSessionStorage(row);
      if (savedPerPage) {
        this.paramsPaginator.size = savedPerPage;
      }
      await this.fetchCompanyData(row)
    },

    async fetchCompanyData(row, pagination) {
      const params = {
        self: this,
        userId: row.userId,
        saveData: {
        },
        query: {
          page: pagination?.page || this.paramsPaginator.page,
          size: pagination?.size || this.paramsPaginator.size,
          lang: this.$store.state.common.lang,
          orderDir: this.paramsPaginator.orderDir,
          orderBy: this.paramsPaginator.orderBy,
        },
      };
      const res = await ApiService(API_METHODS.GET_UserCompany, params);
      this.paramsPaginator.countPage = res.countPage
      this.$set(this.loadDataCompany,  row.userId, {
        ...res,
        size: this.paramsPaginator.size || DEFAULT_PER_PAGE
      });
    },


    deleteParams(id) {
      return { id:id };
    },

    alternativeConverter(dataNow, langNow) {
      if (dataNow && dataNow.length > 0) {
        let tempdataNow = convertLangDataToTable(dataNow, langNow, FIELD_LANG_CODE, true);
        tempdataNow = tempdataNow.map(item => {
          return {
           ...item, isActive: item.isActive?this.$t('Да'):this.$t("Нет"), validDate :  formatData(item.validDate)
          };
        });
        return tempdataNow;
      }

      return [];
    }
  }
};
</script>

<style >
.userPage {
  overflow: visible;
}
.userPage .el-table__body-wrapper {
  overflow: visible;
}


</style>
